// utility function to generate temp keys used on Front end
// keys needs to be sequential as they are used to order messages
// tempId takes last_message_id (e.g. 185) or another previously generated tempId (e.g. 290-2)
// and provides the next suitable sequence tempId (e.g. 185-1, 290-3)
export const generateTempId = last_message_id => {
  const idParts = last_message_id.toString().split('-')

  if (idParts.length === 1) {
    const id = parseInt(idParts[0], 10)
    return `${id}-1`
  } else {
    const id = parseInt(idParts[0], 10)
    const subId = parseInt(idParts[1], 10)
    return `${id}-${subId + 1}`
  }
}

// Helper function to extract base temp_id (e.g., "abc123" from "abc123-1")
export const getBaseTempId = message => {
  if (!message.tempId) {
    return null
  }

  if (!message.tempId.includes('-')) {
    return message.tempId
  }

  const parts = message.tempId.split('-')
  return parts.length > 1 ? parts[0] : null
}
